import { MarketplaceResourcePackage } from '../../../resources/MarketplaceResourcePackage';
import { NftPin } from '../NftPin';
import { Sprite } from 'pixi.js';

export class MyMarketplacePin extends Sprite {
    private nft: NftPin;

    public constructor(marketplaceResources: MarketplaceResourcePackage) {
        super(marketplaceResources.assets_views_marketplace_pins_green_pin_png);
        this.build();
    }

    private build(): void {
        this.nft = new NftPin();
        this.nft.position.set(-this.nft.width * 0.48, -this.nft.height * 0.68);
        this.addChild(this.nft);
    }

    public updateNftTexture(textureUrl: string): void {
        this.nft.updateNftTexture(textureUrl);
    }
}